import {useEffect, useState} from "react";
import {useAuthContext} from "./useAuthContext";
import {auth} from "../../firebase/config";
import firebase from "firebase";
import Persistence = firebase.auth.Auth.Persistence;

export const useLogin = () => {
    const [error, setError] = useState<string | null>(null)
    const [isPending, setIsPending] = useState<boolean>(false)

    const {dispatch} = useAuthContext();

    const login = async  (email: string, pw: string) => {
        resetError();
        setIsPending(true);

        try {
            const res = await auth.setPersistence(Persistence.LOCAL).then(
                () => auth.signInWithEmailAndPassword(email, pw)
            )
            if(dispatch) {
                dispatch({type: 'LOGIN', payload: res.user});
            }
            setIsPending(false);
            resetError();

        } catch (e: any) {
            try{
               const error = JSON.parse(e.message);
               if(error.error.code === 400) {
                   setError('Credenziali non valide');
               }
            }
            catch (a) {
                setError(e.message);
            }
            setIsPending(false);
        }
    };

    const resetError = () => {
        setError(null);
    }

    return {
        login,
        resetError,
        error,
        isPending,
    }
}